enum View {
    Preview,
    CODE,
    EDIT,
    CSS,
}

export default View;
